import HorsesListItem from './HorsesListItem';

export default HorsesListItem;
